import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Typography,
  Box,
  IconButton,
} from "@material-ui/core";
import { Delete, Add } from "@material-ui/icons";
import { toast } from "react-toastify";

const ACOES = [
  { v: "direct", t: "Enviar mensagem no direct", d: "Manda uma DM para quem acionou a automação." },
  { v: "porta", t: "Mandar cartão com botão", d: "Cartão com um botão que a pessoa toca para continuar. Ligue o próximo nó em \"Aguarda resposta\" — o toque chega lá e o fluxo segue." },
  { v: "comentario", t: "Responder o comentário", d: "Resposta pública embaixo do post. Só funciona quando o fluxo veio de um comentário." },
  { v: "curtir", t: "Curtir o comentário", d: "Só funciona quando o fluxo veio de um comentário." },
];

const FlowBuilderIgActionModal = ({ open, onSave, onUpdate, data, close }) => {
  const [activeModal, setActiveModal] = useState(false);
  const [acao, setAcao] = useState("direct");
  const [texto, setTexto] = useState("");
  const [botoes, setBotoes] = useState([]);
  const [rotuloBotao, setRotuloBotao] = useState("");

  const atual = ACOES.find((a) => a.v === acao) || ACOES[0];

  useEffect(() => {
    if (open === "edit") {
      const d = data?.data || data || {};
      setAcao(d.acao || "direct");
      setRotuloBotao(d.rotuloBotao || "");
      setTexto(d.texto || "");
      setBotoes(Array.isArray(d.botoes) ? d.botoes : []);
      setActiveModal(true);
    } else if (open === "create") {
      setAcao("direct");
      setTexto("");
      setBotoes([]);
      setActiveModal(true);
    }
  }, [open, data]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSave = () => {
    if (acao !== "curtir" && !String(texto).trim()) {
      toast.error("Escreva a mensagem.");
      return;
    }
    const payload = {
      acao,
      rotuloBotao: acao === "porta" ? String(rotuloBotao).trim() : "",
      texto: String(texto).trim(),
      botoes: acao === "direct" ? botoes.filter((b) => b.titulo && b.url) : [],
    };
    if (open === "edit") {
      onUpdate({ ...data, data: { ...(data?.data || {}), ...payload } });
    } else {
      onSave(payload);
    }
    handleClose();
  };

  const dica = { fontSize: 11.5, color: "#6b7280", display: "block", marginTop: 6, lineHeight: 1.5 };

  return (
    <Dialog open={activeModal} onClose={handleClose} maxWidth="xs" fullWidth scroll="paper">
      <DialogTitle>
        {open === "create" ? "Adicionar ação do Instagram" : "Editar ação do Instagram"}
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          select
          label="O que fazer"
          value={acao}
          onChange={(e) => setAcao(e.target.value)}
          fullWidth
          size="small"
          variant="outlined"
        >
          {ACOES.map((a) => (
            <MenuItem key={a.v} value={a.v}>
              {a.t}
            </MenuItem>
          ))}
        </TextField>
        <Typography style={dica}>{atual.d}</Typography>

        {acao !== "curtir" && (
          <>
            <TextField
              label="Mensagem"
              value={texto}
              onChange={(e) => setTexto(e.target.value)}
              fullWidth
              multiline
              minRows={3}
              size="small"
              variant="outlined"
              style={{ marginTop: 16 }}
            />
            <Typography style={dica}>
              Use <b>{"{{usuario}}"}</b> para citar quem acionou e as variáveis do fluxo,
              como <b>{"{{resposta}}"}</b>.
            </Typography>
          </>
        )}

        {acao === "porta" && (
          <Box style={{ background: "#faf5ff", padding: 12, borderRadius: 8, marginTop: 14 }}>
            <Typography style={{ fontSize: 12, color: "#6b21a8", marginBottom: 10 }}>
              Tocar no botão envia o texto dele como mensagem. É isso que reabre a
              janela de resposta do Instagram e faz o fluxo continuar — botão de
              link não serve, porque não gera mensagem.
            </Typography>

            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="Texto do botão"
              placeholder="Quero o link"
              value={rotuloBotao}
              onChange={(e) => setRotuloBotao(e.target.value)}
              inputProps={{ maxLength: 20 }}
            />
            <Typography style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }}>
              Até 20 caracteres. Vazio usa "Quero o link".
            </Typography>

            <Box
              style={{
                background: "#f9fafb",
                borderRadius: 10,
                padding: 10,
                marginTop: 12,
                borderLeft: "3px solid #d8b4fe"
              }}
            >
              <Typography style={{ fontSize: 11, color: "#6b7280", marginBottom: 6 }}>
                COMO A PESSOA VÊ
              </Typography>
              <Typography
                style={{
                  fontSize: 12,
                  color: "#374151",
                  whiteSpace: "pre-wrap",
                  marginBottom: 6
                }}
              >
                {texto || "Toca no botão abaixo:"}
              </Typography>
              <Box
                style={{
                  border: "1px solid #d1d5db",
                  borderRadius: 16,
                  padding: "4px 10px",
                  fontSize: 11,
                  color: "#4b5563",
                  textAlign: "center",
                  background: "#fff"
                }}
              >
                {rotuloBotao || "Quero o link"}
              </Box>
            </Box>

            <Typography style={{ fontSize: 11, color: "#7c3aed", marginTop: 10 }}>
              Depois deste nó, ligue um <b>Aguarda resposta</b>. Sem ele o fluxo
              manda o cartão e segue adiante sem esperar o toque.
            </Typography>
          </Box>
        )}

        {acao === "direct" && (
          <Box style={{ marginTop: 16, paddingTop: 12, borderTop: "1px solid #e5e7eb" }}>
            <Typography style={{ fontSize: 13, fontWeight: 600 }}>
              Botões com link (até 3)
            </Typography>
            {botoes.map((b, i) => (
              <Box key={i} style={{ display: "flex", gap: 8, marginTop: 8 }}>
                <TextField
                  placeholder="Texto"
                  value={b.titulo || ""}
                  onChange={(e) => {
                    const l = [...botoes];
                    l[i] = { ...l[i], titulo: e.target.value };
                    setBotoes(l);
                  }}
                  size="small"
                  variant="outlined"
                  inputProps={{ maxLength: 20 }}
                  style={{ width: 150 }}
                />
                <TextField
                  placeholder="https://..."
                  value={b.url || ""}
                  onChange={(e) => {
                    const l = [...botoes];
                    l[i] = { ...l[i], url: e.target.value };
                    setBotoes(l);
                  }}
                  size="small"
                  variant="outlined"
                  style={{ flex: 1 }}
                />
                <IconButton
                  size="small"
                  onClick={() => setBotoes(botoes.filter((_, x) => x !== i))}
                >
                  <Delete fontSize="small" style={{ color: "#dc2626" }} />
                </IconButton>
              </Box>
            ))}
            {botoes.length < 3 && (
              <Button
                size="small"
                startIcon={<Add />}
                onClick={() => setBotoes([...botoes, { titulo: "", url: "" }])}
                style={{ textTransform: "none", marginTop: 8 }}
              >
                Adicionar botão
              </Button>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderIgActionModal;
